// extracted by mini-css-extract-plugin
export var arrowButton = "CarouselButtons_arrowButton__3I9e5";
export var arrowButtonLeft = "CarouselButtons_arrowButtonLeft__UkmCt";
export var arrowButtonRight = "CarouselButtons_arrowButtonRight__-Vte1";
export var container = "CarouselButtons_container__8KcZA";